// extracted by mini-css-extract-plugin
module.exports = {"text":"Consent_text__1sI0d"};